import { useEffect, useState } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 599px)").matches
  );
  useEffect(() => {
    const handleResize = () => {
      let x = window.matchMedia("(max-width: 599px)");
      setIsMobile(x.matches);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile };
};

export default useIsMobile;
